import {Directive, Input, NgModule} from '@angular/core';

@Directive({
  selector: '[sdTooltip]',
  standalone: true,
  host: {
    '[attr.title]': 'sdTooltip',
  },
})
export class SdTooltip {
  @Input() sdTooltip = '';
  @Input() sdTooltipPosition: 'above' | 'below' | 'left' | 'right' | string = 'below';
  @Input() sdTooltipShowDelay: number | string = 0;
  @Input() sdTooltipHideDelay: number | string = 0;
  @Input() sdTooltipDisabled = false;
}

@NgModule({
  imports: [SdTooltip],
  exports: [SdTooltip],
})
export class SdTooltipModule {}
